var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMilitary = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF00",
  d: "M15.6 23.6H8.4L11 13 8.4 23.5zL13 13zq.15-.15 0 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF00",
  d: "M23.5 15.7 13 13.1zV8.5L13 11.1l10.5-2.6zc.1-.1.1 0 0 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF00",
  d: "m7.8 24 2.6-10.4h3.3v-3.2h-3.3v3.2L0 16.2V7.8l10.3 2.5L7.8 0h8.4l-2.5 10.3L24 7.8v8.4l-10.3-2.5L16.3 24z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#D41A65",
  d: "M8.4.5h7.2L13 11h-2zm15.1 7.9v7.2L13 13v-2zM8.4 23.5 11 13h2l2.6 10.5zM.5 15.6V8.4L11 11v2z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF00",
  d: "M12 16.7a4.7 4.7 0 1 0 0-9.4 4.7 4.7 0 0 0 0 9.4"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#29327D",
  d: "M12 16.2a4.2 4.2 0 1 0 0-8.4 4.2 4.2 0 0 0 0 8.4"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEDF00",
  d: "M12 8.2c-.5.7-.1 1-.2 2.7 0 .8-.3 1.5-.6 2.2-.7 0-.7-.8-.1-.8-.1-1.7-.3-2.8-1.4-3.5v5.6H11c.1.8.8 1.3 1 1.5.2-.3.9-.7 1-1.5h1.3V8.8c-1.2.6-1.3 1.7-1.4 3.5.6 0 .6.8-.1.8-.3-.7-.6-1.3-.6-2.2-.1-1.8.3-2-.2-2.7m-1.9 1.4c.5.7.5 1.4.6 2.4-.2.1-.3.3-.4.5h-.2zm3.8 0v2.8h-.2c0-.2-.2-.4-.4-.5.1-.9.1-1.6.6-2.3M12 12.2c.1.3.2.7.4 1-.2.1-.3.1-.4.3-.1-.1-.3-.2-.4-.3.2-.4.3-.7.4-1m-1.9.6h.2c.2.4.3.5.7.6 0 .2-.1.4-.1.6H10zm3.6 0h.3V14h-.9c0-.2 0-.4-.1-.6.4-.1.6-.2.7-.6m-2.3.7c.2 0 .4.2.4.5h-.5c.1-.2.1-.4.1-.5m1.2 0c0 .1 0 .3.1.5h-.5c0-.3.2-.5.4-.5m-1.2.8h.4v.8c-.2-.2-.4-.4-.4-.8m.8 0h.4c0 .3-.2.6-.4.8z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMilitary);
export default ForwardRef;